module.exports = __webpack_public_path__ + "images/moonshot/circle.1fef8369d51cc01b86e4.svg";